module.exports = __webpack_public_path__ + "static/media/no-img.5a021ab9.png";